import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "news-details-content" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "news-details" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "sub-content" }
const _hoisted_6 = { class: "views" }
const _hoisted_7 = { class: "author" }
const _hoisted_8 = { class: "createTime" }
const _hoisted_9 = ["innerHTML"]

import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action } from '@/typeDefine/CommonTypes';
import { GetNewsDetailsResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';
import NavBar from '@/components/NavBar.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Footer from '@/components/Footer.vue';
import { BreadType } from '@/typeDefine/EntityType';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsDetails',
  setup(__props) {

const route = useRoute()
const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

const breadList: BreadType[] = [
    {
        to: '/newsList',
        text: 'index.navBar.news'
    },
    {
        text: 'index.navBar.newsDetails'
    }
]
const details: Ref<GetNewsDetailsResponse['data']['details'] | null> = ref(null)

onMounted(() => {

    if (typeof route.params.id === 'string') {
        requestNewsDetails(route.params.id)
    }

})

//获取新闻详情
const requestNewsDetails: Action<[string]> = async (id: string) => {
    const response: GetNewsDetailsResponse = await Api.instance.getNewsDetails({
        id,
    })

    UtilMethods.showMessageToast(response,false)
    if(response.code === ResponseCode.OK) {
        details.value = response.data.details
    }else {
        router.replace({
            name: 'newsList'
        })
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { "z-index": _unref(maxZIndex) }, {
      default: _withCtx(() => [
        _createVNode(NavBar)
      ]),
      _: 1
    }, 8, ["z-index"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Breadcrumb, { "bread-list": breadList }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(details.value?.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('newsDetails.views')) + "：" + _toDisplayString(details.value?.views), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('newsDetails.author')) + "：" + _toDisplayString(details.value?.author), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('newsDetails.createTime')) + "：" + _toDisplayString(_unref(UtilMethods).formatDataOfPattern(details.value?.createTime,'YYYY/MM/DD')), 1)
        ]),
        _createElementVNode("div", {
          class: "content",
          innerHTML: details.value?.content
        }, null, 8, _hoisted_9)
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})